import React from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";

/** Connie's replies: bold, lists and links only. Internal paths open in the app, not a new tab. */
const A = ({ href = "", children }) =>
  href.startsWith("/")
    ? <Link to={href}>{children}</Link>
    : href.startsWith("mailto:")
      ? <a href={href}>{href.slice(7)}</a>
      : <a href={href} target="_blank" rel="noreferrer">{children}</a>;

export const ConnieText = ({ text, className = "" }) => (
  <div className={`connie-md ${className}`}>
    <ReactMarkdown components={{ a: A, h1: "p", h2: "p", h3: "p", h4: "p", img: () => null }}>
      {(text || "").replace(/\n+- Connie\s*$/, "\n\n\\- Connie")}
    </ReactMarkdown>
  </div>
);

export default ConnieText;
